<template>
  <div id="app">
    <progress-bar></progress-bar>
    <router-view />
  </div>
</template>

<script>
import ProgressBar from "./components/ProgressBar.vue";
export default {
  components: { ProgressBar },
};
</script>

<style>
/* width */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(185, 185, 185);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(112, 112, 112);
}
#app {
  height: 60em;
}
.menu-list a:hover {
  background-color: #1d292e !important;
  color: #363636 !important;
}
</style>
